import { render, staticRenderFns } from "./PFormInputPredictiveSearch.vue?vue&type=template&id=fb136c6a&scoped=true&"
import script from "./PFormInputPredictiveSearch.vue?vue&type=script&lang=ts&"
export * from "./PFormInputPredictiveSearch.vue?vue&type=script&lang=ts&"
import style0 from "./PFormInputPredictiveSearch.vue?vue&type=style&index=0&id=fb136c6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb136c6a",
  null
  
)

export default component.exports